import PropTypes from 'prop-types'
import { useId } from 'react'
import { cloneElement, isValidElement } from 'react'

const SettingsRow = ({ label, children, isFirst = false, isLast = false }) => {
  const generatedId = useId()
  
  // Clone the child element and add an id if it doesn't have one
  const childWithId = isValidElement(children) && children.type === 'input' 
    ? cloneElement(children, { 
        id: children.props.id || generatedId,
        'aria-label': children.props['aria-label'] || label 
      })
    : children

  const inputId = isValidElement(children) && children.type === 'input' 
    ? children.props.id || generatedId 
    : null
  
  return (
    <div className={`${!isLast ? 'border-b border-border-divider' : ''}`}>
      <div className="flex items-center justify-between px-spacing-4 py-spacing-2">
        <label 
          {...(inputId ? { htmlFor: inputId } : {})}
          className="text-[14px] text-primary"
        >
          {label}
        </label>
        <div>
          {childWithId}
        </div>
      </div>
    </div>
  )
}

SettingsRow.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
}

export default SettingsRow